import React from "react";
import ProfileImg from "@icarius-common/profileImg";
import { Tooltip, Typography } from "@material-ui/core";
import DotsMenu from "@icarius-common/dotsMenu";
import { parse } from "date-fns";
import { formatDistanceToNow } from "date-fns";
import { dateLocale } from "@icarius-localization/strings";
import { getLocalizedString } from "@icarius-localization/strings";

const Header = (props) => {

    const {
        image,
        name,
        date,
        time,
        edited,
        hasMenu,
        menuOptions,
    } = props;

    return (
        <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{ flex: 1, display: "flex", alignItems: "center", flexWrap: "wrap", gap: 15 }}>
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                    <ProfileImg
                        image={image}
                        size={30}
                    />
                    <div>
                        <Typography className="whiteText" style={{ fontWeight: 600 }}>
                            {name}
                        </Typography>
                        <Tooltip title={`${date} - ${time}`} arrow>
                            <Typography
                                variant="caption"
                                className="whiteText firstLetterUppercase"
                                style={{
                                    fontWeight: 500,
                                }}
                            >
                                {`${formatDistanceToNow(parse(`${date} ${time}`, "dd-MM-yyyy HH:mm", new Date()), { addSuffix: true, locale: dateLocale })}${edited ? ` (${getLocalizedString("edited")})` : ""}`}
                            </Typography>
                        </Tooltip>
                    </div>
                </div>
            </div>
            {
                hasMenu &&
                <DotsMenu noPadding>
                    {menuOptions}
                </DotsMenu>
            }
        </div>
    )
}

export default Header;